function ShoppingIcon() {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64.000000 64.000000"
      preserveAspectRatio="xMidYMid meet"
      width="20"
      height="20"
      style={{ color: "#fff", marginLeft: "7px" }}
    >
      <g
        transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
        fill="#ffffff"
        stroke="none"
      >
        <path
          d="M303 567 c-40 -24 -76 -46 -79 -50 -4 -4 47 -7 114 -7 l122 0 -31 50
c-17 28 -36 50 -42 50 -7 0 -45 -20 -84 -43z"
        />
        <path
          d="M29 561 l-29 -29 0 -227 0 -226 25 -24 24 -25 255 0 c252 0 255 0
270 22 9 12 16 35 16 50 0 26 -3 28 -40 28 -112 0 -181 92 -135 180 20 39 48
53 115 60 51 5 55 7 58 33 2 16 -4 39 -13 53 l-15 24 -243 0 c-245 0 -273 4
-260 36 3 9 22 14 56 14 36 0 63 7 94 25 23 14 43 28 43 30 0 3 -43 5 -96 5
-92 0 -97 -1 -125 -29z"
        />
        <path
          d="M470 571 c0 -5 9 -19 20 -32 21 -26 27 -11 10 22 -11 19 -30 26 -30
10z"
        />
        <path
          d="M465 305 c-32 -31 -32 -66 -1 -102 22 -26 30 -28 98 -28 l73 0 3 78
3 77 -76 0 c-67 0 -79 -3 -100 -25z m72 -36 c15 -15 5 -39 -17 -39 -22 0 -32
24 -17 39 6 6 14 11 17 11 3 0 11 -5 17 -11z"
        />
      </g>
    </svg>
  );
}

export default ShoppingIcon;
